import { Injectable, signal } from '@angular/core';

import { LoggedUser } from '../interfaces/user.interface';

@Injectable({
    providedIn: 'root',
})
export class SubscriberUserTypesService {
    private readonly _isLiteUser = signal<boolean>(false);

    readonly isLiteUser = this._isLiteUser.asReadonly();

    /**
     *
     * @param user
     */
    setFromUser(user: LoggedUser | null | undefined): void {
        this._isLiteUser.set(user?.lite === 'Y');
    }
}
